<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-atom"></ngx-spinner>
<app-header-bar (onNavigate)="currentNavigation=$event;goTo()"></app-header-bar>
<router-outlet></router-outlet>
